module.exports = __webpack_public_path__ + "media/images/home/black_and_mobile-d0e0b42021f47bfa445ee6b1e779b557.png";